import licenseModule from '../../license.module';

export default licenseModule.component('licenseViewPerpetual', {
    template: require('./licenseViewPerpetual.component.html'),
    controller: ['entitlementConstants', licenseViewPerpetualComponent],
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

function licenseViewPerpetualComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;

    vm.$onInit = function() {
        var navs = [
            {
                label: 'Perpetual',
                value: 'perpetual'
            }
        ];
        vm.nav = {
            options: {},
            items: navs,
            step: 0,
            selected: navs[0],
            selectedValue: function() {
                return this.selected.value;
            }
        };
        vm.data = vm.resolve.data;
    };

    vm.ok = function() {
        vm.close({ $value: vm.receipt });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-view-perpetual/licenseViewPerpetual.component.js